<div class="page-container">
  <app-page-header title="Payments">
    <div class="header-actions" header-actions>
      <input
        pInputText
        placeholder="Customer ID"
        [(ngModel)]="customerIdFilter"
      />
      <input
        pInputText
        placeholder="Reference ID"
        [(ngModel)]="referenceIdFilter"
      />
      <p-button icon="pi pi-search" label="Apply" severity="primary" size="small" (onClick)="applyFilters()"></p-button>
      <p-button
        icon="pi pi-filter-slash"
        label="Clear"
        severity="secondary"
        [disabled]="!hasActiveFilters()"
        [text]="true"
        (onClick)="clearFilters()"
      ></p-button>
    </div>
  </app-page-header>

  <p-table [value]="allPayments()" [loading]="loading()">
    <ng-template pTemplate="header">
      <tr>
        <th>Payment ID</th>
        <th>Customer ID</th>
        <th>Reference ID</th>
        <th>Reference Type</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Provider</th>
        <th>Payment Date</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-payment>
      <tr>
        <td>{{ payment.paymentHistoryId }}</td>
        <td>{{ payment.youtopiaCustomerId }}</td>
        <td>{{ payment.referenceId }}</td>
        <td>{{ payment.referenceType }}</td>
        <td>{{ payment.amountPaid | currency: payment.currency }}</td>
        <td>{{ payment.paymentStatus }}</td>
        <td>{{ payment.providerType }}</td>
        <td>{{ payment.paymentDate | date: 'short' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty-message-cell" colspan="8">
          <p-message severity="info">No payments found.</p-message>
        </td>
      </tr>
    </ng-template>
  </p-table>

  @if (paging().nextToken) {
    <div class="load-more">
      <p-button label="Load More" severity="secondary" [outlined]="true" [loading]="loading()" (onClick)="loadMore()"></p-button>
    </div>
  }
</div>
